import { create } from 'zustand';

export interface LibraryAlbum {
  id?: number;
  album_key: string;
  title: string;
  artist_name?: string;
  year?: number;
  genre?: string;
  format?: string;
  sample_rate?: number;
  bit_depth?: number;
  cover_art_url?: string;
  enriched_at?: string;
  enrichment_status?: string;
  track_count?: number;
  total_duration?: number;
  is_hires?: boolean;
  is_lossless?: boolean;
  is_compilation?: boolean;
  machine_id?: string;
  source_id?: string;
  created_at?: string;
  updated_at?: string;
  cover_art_updated_at?: string;
  cover_art_source?: string;
}

export interface LibraryStats {
  success?: boolean;
  total?: number;
  total_albums?: number;
  albums?: number;
  formats?: Record<string, number>;
  hires_count?: number;
  lossless_count?: number;
}

interface LibraryState {
  albums: LibraryAlbum[];
  total: number;
  stats: LibraryStats | null;
  sort: string;
  filter: string;
  formatFilter: string;
  scrollOffset: number;

  setAlbums: (albums: LibraryAlbum[], total: number) => void;
  appendAlbums: (albums: LibraryAlbum[]) => void;
  setStats: (stats: LibraryStats) => void;
  setSort: (sort: string) => void;
  setFilter: (filter: string) => void;
  setFormatFilter: (format: string) => void;
  setScrollOffset: (offset: number) => void;
  invalidate: () => void;
}

export const useLibraryStore = create<LibraryState>()((set) => ({
  albums: [],
  total: 0,
  stats: null,
  sort: 'artist',
  filter: 'all',
  formatFilter: '',
  scrollOffset: 0,

  setAlbums: (albums, total) => set({ albums, total }),

  appendAlbums: (newAlbums) =>
    set((state) => ({
      albums: [...state.albums, ...newAlbums],
    })),

  setStats: (stats) => set({ stats }),

  setSort: (sort) => set({ sort }),
  setFilter: (filter) => set({ filter }),
  setFormatFilter: (formatFilter) => set({ formatFilter }),
  setScrollOffset: (scrollOffset) => set({ scrollOffset }),

  invalidate: () =>
    set({ albums: [], total: 0, stats: null, scrollOffset: 0 }),
}));
